inputs-complex-radio-status
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span.radio-wrap(each="{item, index in opts.items}")
        input(if="{ item.value == parent.opts.value }" checked="checked" id="{this.tagScope}_{index}" type="radio" value="{ item.value }" name="{ parent.opts.name }" onChange="{ parent.onChange }")
        input(if="{ item.value != parent.opts.value }" id="{this.tagScope}_{index}" type="radio" value="{ item.value }" name="{ parent.opts.name }" onChange="{ parent.onChange }")
        label(for="{this.tagScope}_{index}") { item.label }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.complex.radio-status');
  style(scoped).
    .radio-wrap {
      display: inline-block;
      margin-right: .5em;
      margin-top: .5em;
    }
